<template>
  <svg data-name="diapositiva 3" :viewBox="buttonId==1?'0 10 380 145':'390 10 380 145'" xmlns="http://www.w3.org/2000/svg">
    <path fill="#043" d="M7 6.71h373.9v132.9H7z"/>
    <path class="cls-2" d="M358.71 139.63V32.45h-37.85v5.94h-90.57v49.79l-.55.29v51.16zm-113.84-85h45.33l-45.33 24.53zM327.8 18.02h27.11V31.6H327.8z"/>
    <path class="cls-3" d="M108 43.67h154v59H108z"/>
    <g id="boton1" :class="{'fix-svg-origin hvr hvr-scale': active}" @click="active?$emit('mostrar',1):null">
      <circle class="cls-3" cx="84.54" cy="73.17" r="56.5"/>
      <circle cx="84.54" cy="73.17" r="52.74" fill="#ffe131"/>
      <path class="cls-5" d="M32.13 67.28a54.49 54.49 0 0 0-.33 5.89 52.74 52.74 0 0 0 105.48 0 54.49 54.49 0 0 0-.33-5.89z"/>
      <path class="cls-6" d="M71.67 42.92h40.83v25.24h-5.94V49.6H71.67z"/>
      <path class="cls-6" d="M112.7 112.3H56.34V40.32H72.9v2.97l39.8 21.53z"/>
      <path fill="#1b8c9b" d="M58.03 34.01h11.85v5.94H58.03z"/>
      <circle class="cls-3" cx="84.54" cy="85.98" r="20.79"/>
      <path d="M93.82 89.32a9.28 9.28 0 0 1-18.56 0c0-5.13 8.91-16.71 9.28-16.71s9.28 11.58 9.28 16.71z"/>
    </g>
    <text class="cls-8" transform="translate(160 71.28)">
      Debido <tspan x="0" y="20">a que…</tspan>
    </text>
    <path fill="#beeb7b" d="M384.8 6.71h373.9v132.9H384.8z"/>
    <path d="M422.26 139.63h4.13l1.61-34.27a4.8 4.8 0 0 0 4.32 1.58 4.37 4.37 0 0 0 4.11 1c4.31-1.31 6.59-9.71 6.84-10.67v-.15a160 160 0 0 0 .68-18.89L501 62.05l-1.06 7.45h-.66v7.72h.06L488 139.63h13.52l9.57-62.41h3.16L530 139.63h8.31l-17.17-68h-.32V69.5h-.66l-1.59-11.16h-4.47l69.31-19.6 4.92 13.79-4.72 3.15.16.64c1.71 6.85 3.93 10.73 6.76 11.84l17 45.51-.45.18h-48.42a3.35 3.35 0 0 0-3.34 3.34v9.16a2.83 2.83 0 0 0-1.59 2.52v10.76H562v-8h25.12c-.23 2.08.55 4.81 4.28 7.71l-.12.25h61l.38-.67-1.31-1 4-2.18s4-1.72 5-5.05h4a1.94 1.94 0 0 0 .63-.11l30.24-11h1a2.4 2.4 0 0 0 0-4.79h-53.61a73.82 73.82 0 0 0-10.75-3.33l-.43-1.18h-3.19l-22-60.76c.76-5.68-.42-12.84-5.67-21.58l-6.44 3-.14-.25L589.76 15l.85-.24-1.7-3.07L438 54.34c-3.65-6.65-8.24-7.69-10.17-7.81-.29-.15-.58-.27-.85-.38l-.24-.09-.62-.21-.17-.06c-.24-.07-.47-.12-.69-.17h-.15c-.18 0-.34-.06-.49-.08h-.16a6.52 6.52 0 0 0-.8 0h-.46c-1-.06-1.93-.1-2.81-.1h-2.82l-.64.06-.43.06-.57.08-.42.07-.51.1-.4.08-.46.12-.37.1-.43.12-.34.11-.39.14-.31.12a3 3 0 0 0-.36.16l-.29.12-.33.17-.25.13-.31.17-.23.14-.28.19-.2.13-.26.2a1.09 1.09 0 0 1-.17.13l-.25.23a.69.69 0 0 0-.13.11 6.72 6.72 0 0 0-.64.68l-.09.11a1.84 1.84 0 0 1-.17.22l-.09.14-.13.19-.12.18-.11.19a.61.61 0 0 0-.07.14l-.09.17-.06.13-.07.16a1.12 1.12 0 0 0-.05.13c0 .05 0 .11-.06.15s0 .08 0 .12l-.05.15v.23a.44.44 0 0 0 0 .1v.2a.36.36 0 0 0 0 .1v.07a.25.25 0 0 0 0 .08v.24c-.4 20.59 11 38.82 16.85 46.77zm174-18.9a9.5 9.5 0 0 0-2.26 2.69 28 28 0 0 0-3.39 2.65H562v-5.55h34.5zm82.8-.21l-15.21 5.55h-3a15 15 0 0 0-3.81-4.8l-.07-.07s-.38-.27-1-.68zm-75.67-60.85l18.66 50.05a70.45 70.45 0 0 0-8.52 1.87l-16.4-45.39a26.46 26.46 0 0 0 6.26-6.53z" fill="#b3dd6b"/>
    <path class="cls-3" d="M483 55.17h182v36H483z"/>
    <text class="cls-8" transform="translate(501 79.91)">
      Porque…
    </text>
    <g id="boton2" :class="{'fix-svg-origin hvr hvr-scale': active}" @click="active?$emit('mostrar',2):null">
      <circle class="cls-3" cx="681.5" cy="73.17" r="56.5"/>
      <circle class="cls-5" cx="681.5" cy="73.17" r="52.74"/>
      <path d="M629.6 82.28a52.73 52.73 0 0 0 103.9 0z" fill="#5b9b00"/>
      <path fill="#292929" d="M704.4 59.86h3.8v34.22h-3.8z"/>
      <path class="cls-13" d="M672 78.87h19.01v3.8H672z"/>
      <path class="cls-14" d="M681.5 78.87h9.5v3.8h-9.5z"/>
      <path class="cls-13" d="M696.1 98.34l-2.51 2.89-12.05-10.34-12 10.34-2.54-2.89 11.63-10-7.37-6.31 2.51-2.89 7.79 6.69 8.17-7 2.47 2.89-7.71 6.62z"/>
      <path class="cls-14" d="M696.1 98.34l-2.51 2.89-12.05-10.34v-5l8.17-7 2.47 2.89-7.71 6.62z"/>
      <path class="cls-15" d="M702.4 90.28h7.6v11.41h-7.6z"/>
      <path class="cls-13" d="M669.8 101.6l-3.72-.82 9.22-41.46 3.71.82z"/>
      <path class="cls-14" d="M693.4 102.5l-9.06-45.47 3.72-.74 9.07 45.32z"/>
      <path fill="#6e6e6e" d="M649.1 97.88h64.88v7.73H649.1z"/>
      <path fill="#5a5a5a" d="M681.5 97.88h32.44v7.73H681.5z"/>
      <path d="M706.8 52.68l-25.24 10.53-24.46 10.15-.91-7.75L681.56 55l24.33-10.15z" fill="#ff7816"/>
      <path d="M706.8 52.68l-25.24 10.53V55l24.33-10.15z" fill="#ff4b00"/>
      <path class="cls-13" d="M649.1 52.26v15.21l3.8 11.4h7.6V52.26z"/>
      <path class="cls-15" d="M710 59.86l-3.8 3.81-3.8-3.81V40.73h7.6z"/>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    buttonId: {
      type: Number,
      required: true,
      default: 1
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
  .cls-8{fill:#043}.cls-2{fill:#003828}.cls-3{fill:#fff}.cls-5{fill:#00dbd7}.cls-6{fill:#c90e00}.cls-8{font-size:24px;font-family:open-sans,'OpenSans-Bold','Open Sans',helvetica;font-weight:700}.cls-13{fill:#727272}.cls-14{fill:#333}.cls-15{fill:#444}
</style>